import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  emptyStateHeader: {
    id: 'NnMVsT',
    defaultMessage: 'Set Up External Inventory',
    description: 'Header text for external inventory empty state',
  },
  emptyStateDescription: {
    id: 'Xi8Kdu',
    defaultMessage: 'To view external inventory in ShipStation, configure your inventory sources in Inventory Settings.',
    description: 'Description text explaining how to set up external inventory',
  },
  setupSourcesButton: {
    id: 'RUF0UF',
    defaultMessage: 'Set Up Sources',
    description: 'Button text to navigate to inventory sync settings',
  },
  learnMoreButton: {
    id: '6Hkeuq',
    defaultMessage: 'Learn More',
    description: 'Button text for learning more about external inventory',
  },
});
